import { useSelector } from "react-redux";
var useSelectors = function () {
    var _a = useSelector(function (state) { return ({
        responseIdentificationType: state.IdentificationType.responseIdentificationType,
        loadingIdentificationType: state.IdentificationType.loadingIdentificationType,
    }); }), responseIdentificationType = _a.responseIdentificationType, loadingIdentificationType = _a.loadingIdentificationType;
    var _b = useSelector(function (state) { return ({
        responseCatalogGender: state.Plan.responseCatalogGender,
        loadingCatalogGender: state.Plan.loadingCatalogGender,
    }); }), responseCatalogGender = _b.responseCatalogGender, loadingCatalogGender = _b.loadingCatalogGender;
    return {
        responseIdentificationType: responseIdentificationType,
        loadingIdentificationType: loadingIdentificationType,
        responseCatalogGender: responseCatalogGender,
        loadingCatalogGender: loadingCatalogGender,
    };
};
export default useSelectors;
